// frontend/src/components/AppTypeForm.js
import React from 'react';
import OctoAppTypeForm from './AppTypeForm/OctoAppTypeForm';
import InfraAppTypeForm from './AppTypeForm/InfraAppTypeForm';

const AppTypeForm = (props) => {
    const { appType } = props;

    if (appType === "Octo+ App") {
        return <OctoAppTypeForm {...props} />;
    } else if (appType === "Infra App") {
        return <InfraAppTypeForm {...props} />;
    } else {
        return null;
    }
};

export default AppTypeForm;
